import { render, staticRenderFns } from "./ItemWithLinkEl.vue?vue&type=template&id=325327e9&scoped=true&"
import script from "./ItemWithLinkEl.vue?vue&type=script&lang=ts&"
export * from "./ItemWithLinkEl.vue?vue&type=script&lang=ts&"
import style0 from "./ItemWithLinkEl.vue?vue&type=style&index=0&id=325327e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325327e9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VImg,VSheet})
